export default __webpack_public_path__ + "static/media/github.61501037.svg";